import { render, staticRenderFns } from "./AgentRejectionAlert.vue?vue&type=template&id=51748703"
import script from "./AgentRejectionAlert.vue?vue&type=script&lang=js"
export * from "./AgentRejectionAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports